module.exports = __webpack_public_path__ + "console/img/快捷.bcd40c66.jpg";